import { useSelector } from "react-redux";
import { GroupedCartItem } from "src/common/types/cart";
import { RootState } from "toolkit/store";

const useCartItems = () => {
  const items = useSelector((state: RootState) => state.cart.data) as { [key: string]: GroupedCartItem } || {};
  return items;
};

export default useCartItems;
